'use es6';

export const ALIAS = 'ALIAS';
export const FACSIMILE_INBOX = 'FACSIMILE_INBOX';
export const CRM_EMAIL_INTEGRATION = 'CRM_EMAIL_INTEGRATION';

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}